(() => {
  'use strict';
  const key = 'bm-sticky-atc';
  const registry = window.GGStickyATC = window.GGStickyATC || {};
  if (registry[key]) registry[key].destroy();
  let stopped = false, frame = 0;
  const undo = [];
  const tracked = new WeakMap();
  const own = node => { undo.push(() => node.remove()); return node; };
  const text = (node, value) => { if (node.textContent !== value) node.textContent = value; };
  const set = (node, name, value) => { if (node.getAttribute(name) !== value) node.setAttribute(name, value); };
  const drop = (node, name) => { if (node.hasAttribute(name)) node.removeAttribute(name); };
  const flag = (node, name, on) => { if (node.classList.contains(name) !== on) node.classList.toggle(name, on); };
  const shown = (node, on) => { if (node.hidden === on) node.hidden = !on; };
  const attr = (node, name, value) => {
    let names = tracked.get(node);
    if (!names) { names = new Set(); tracked.set(node, names); }
    if (!names.has(name)) {
      names.add(name);
      const old = node.getAttribute(name);
      undo.push(() => old === null ? node.removeAttribute(name) : node.setAttribute(name, old));
    }
    if (node.getAttribute(name) !== value) node.setAttribute(name, value);
  };
  const listen = (node, event, handler, options) => {
    node.addEventListener(event, handler, options);
    undo.push(() => node.removeEventListener(event, handler, options));
  };
  const element = (tag, className, content) => {
    const node = document.createElement(tag);
    if (className) node.className = className;
    if (content) node.textContent = content;
    return node;
  };
  const reducedMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const visible = node => !!node && node.getClientRects().length > 0 && getComputedStyle(node).visibility !== 'hidden';
  const scrollTo = node => {
    node.scrollIntoView({behavior: reducedMotion() ? 'auto' : 'smooth', block: 'center'});
    attr(node, 'tabindex', '-1');
    node.focus({preventScroll: true});
  };
  const style = own(element('style'));
  style.dataset.ggStickyAtc = key;
  style.textContent = `
.gg-bm-scrim {position:fixed;inset:0;z-index:24;background:#12121259;opacity:0;pointer-events:none;transition:opacity .25s ease}
.gg-bm-scrim.is-in {opacity:1;pointer-events:auto}
.gg-bm {position:fixed;inset-inline:0;bottom:0;z-index:25;color:var(--colorTextBody,#181818);transform:translateY(105%);visibility:hidden;transition:transform .3s cubic-bezier(.22,.61,.36,1),visibility .3s}
.gg-bm.is-in {transform:none;visibility:visible}
.gg-bm [hidden] {display:none!important}
.gg-bm-bar {position:relative;z-index:2;display:flex;align-items:center;gap:10px;background:#fff;border-top:1px solid #0000001a;box-shadow:0 -4px 20px #00000014;padding:7px 12px calc(7px + env(safe-area-inset-bottom))}
.gg-bm-summary {flex:1 1 auto;display:flex;align-items:center;gap:10px;min-width:0;min-height:46px;padding:0;border:0;background:none;color:inherit;font:inherit;text-align:left;cursor:pointer}
.gg-bm-summary[disabled] {opacity:1;cursor:default}
.gg-bm-thumb {flex:0 0 auto;width:42px;height:42px;border-radius:9px;object-fit:cover;background:var(--colorSmallImageBg,#f1f1f1)}
.gg-bm-lines {min-width:0;line-height:1.3}
.gg-bm-title {display:none}
.gg-bm-prices {display:flex;align-items:baseline;gap:6px;white-space:nowrap}
.gg-bm-price {font-size:15px;font-weight:700;letter-spacing:-.01em}
.gg-bm-was {font-size:12px;opacity:.55}
.gg-bm-save {padding:1px 6px;border-radius:999px;background:#fdecec;color:#c02616;font-size:11px;font-weight:700}
.gg-bm-variant {display:inline-flex;align-items:center;gap:5px;max-width:100%;font-size:12.5px;font-weight:600;text-decoration:underline;text-decoration-color:#00000040;text-underline-offset:3px}
.gg-bm-variant-value {overflow:hidden;white-space:nowrap;text-overflow:ellipsis}
.gg-bm-caret {flex:0 0 auto;width:8px;height:8px;margin-top:3px;border-left:2px solid currentColor;border-bottom:2px solid currentColor;transform:rotate(135deg);animation:gg-bm-float-up 1.2s ease-in-out infinite}
.gg-bm.is-open .gg-bm-caret {animation:gg-bm-float-down 1.2s ease-in-out infinite}
@keyframes gg-bm-float-up {0%,100%{transform:translateY(2px) rotate(135deg)}50%{transform:translateY(-2px) rotate(135deg)}}
@keyframes gg-bm-float-down {0%,100%{transform:translateY(-2px) rotate(-45deg)}50%{transform:translateY(2px) rotate(-45deg)}}
.gg-bm-cta {position:relative;flex:0 0 auto;display:inline-flex;align-items:center;justify-content:center;max-width:43%;min-height:46px;padding:8px 16px;border:0;border-radius:var(--buttonRadius,12px);background:var(--colorBtnPrimary,#111);color:var(--colorBtnPrimaryText,#fff);font:inherit;font-size:13.5px;font-weight:700;cursor:pointer;transition:transform .12s ease,opacity .2s ease}
.gg-bm-cta:active {transform:scale(.985)}
.gg-bm-cta[disabled] {opacity:.45;cursor:default}
.gg-bm-cta-label {white-space:normal;overflow-wrap:anywhere;text-align:center;line-height:1.3}
.gg-bm-cta.is-busy .gg-bm-cta-label {opacity:0}
.gg-bm-cta.is-busy::after {content:'';position:absolute;inset:0;width:18px;height:18px;margin:auto;border:2px solid currentColor;border-top-color:transparent;border-radius:50%;animation:gg-bm-spin .7s linear infinite}
@keyframes gg-bm-spin {to {transform:rotate(360deg)}}
.gg-bm-sheet {position:absolute;z-index:1;inset-inline:0;bottom:100%;max-height:52vh;padding:12px 14px 14px;overflow-y:auto;overscroll-behavior:contain;background:#fff;border-radius:18px 18px 0 0;box-shadow:0 -12px 34px #00000024;visibility:hidden;transform:translateY(100%);transition:transform .3s cubic-bezier(.22,.61,.36,1),visibility .3s}
.gg-bm.is-open .gg-bm-sheet {visibility:visible;transform:none}
.gg-bm-grip {display:flex;align-items:center;justify-content:center;width:100%;height:20px;margin:0;padding:0;border:0;background:transparent;cursor:pointer}
.gg-bm-grip::before {content:'';width:44px;height:4px;border-radius:999px;background:#00000024}
.gg-bm-sheet-head {display:flex;align-items:center;justify-content:space-between;gap:12px;margin:0 0 12px}
.gg-bm-sheet-title {font-size:15px;font-weight:700;letter-spacing:-.01em}
.gg-bm-close {display:inline-flex;align-items:center;justify-content:center;gap:6px;min-height:36px;padding:0 10px;border:1px solid #00000018;border-radius:999px;background:#f5f5f5;color:inherit;font:inherit;font-size:13px;font-weight:600;cursor:pointer;transition:background-color .15s ease,border-color .15s ease}
.gg-bm-close:hover {background:#ececec;border-color:#00000028}
.gg-bm-close-x {position:relative;display:block;width:12px;height:12px}
.gg-bm-close-x::before,.gg-bm-close-x::after {content:'';position:absolute;left:50%;top:50%;width:12px;height:2px;border-radius:1px;background:currentColor}
.gg-bm-close-x::before {transform:translate(-50%,-50%) rotate(45deg)}
.gg-bm-close-x::after {transform:translate(-50%,-50%) rotate(-45deg)}
.gg-bm-group + .gg-bm-group {margin-top:15px}
.gg-bm-group-head {display:flex;align-items:baseline;justify-content:space-between;gap:10px;margin-bottom:8px}
.gg-bm-group-name {font-size:11.5px;font-weight:600;letter-spacing:.06em;text-transform:uppercase;opacity:.55}
.gg-bm-group-value {font-size:13px;font-weight:600}
.gg-bm-chips {display:flex;flex-wrap:wrap;gap:8px}
.gg-bm-chip {min-width:48px;min-height:42px;padding:0 14px;border:1.5px solid #00000024;border-radius:11px;background:#fff;color:inherit;font:inherit;font-size:14px;font-weight:600;cursor:pointer;transition:border-color .15s ease,background-color .15s ease,color .15s ease}
.gg-bm-chip:hover {border-color:#00000059}
.gg-bm-chip[aria-pressed="true"] {border-color:var(--colorBtnPrimary,#111);background:var(--colorBtnPrimary,#111);color:var(--colorBtnPrimaryText,#fff)}
.gg-bm-chip.is-out {opacity:.42;text-decoration:line-through}
@media(max-width:374px){.gg-bm-thumb,.gg-bm-was {display:none}}
@media(min-width:750px){
.gg-bm-bar {justify-content:center;gap:28px;padding:14px max(40px,calc((100% - 1180px) / 2)) calc(14px + env(safe-area-inset-bottom))}
.gg-bm-summary {flex:1 1 auto;max-width:780px;gap:16px;min-height:56px}
.gg-bm-summary:hover .gg-bm-variant {border-color:#00000044;background:#f0f0f0}
.gg-bm-thumb {width:56px;height:56px;border-radius:10px}
.gg-bm-lines {display:flex;flex-direction:column;gap:5px;min-width:0}
.gg-bm-title {display:block;overflow:hidden;max-width:100%;font-size:15px;font-weight:600;letter-spacing:-.01em;white-space:nowrap;text-overflow:ellipsis}
.gg-bm-meta {display:flex;align-items:center;flex-wrap:wrap;gap:10px 14px}
.gg-bm-prices {gap:8px}
.gg-bm-price {font-size:17px}
.gg-bm-was {font-size:13px}
.gg-bm-save {padding:2px 7px;font-size:12px}
.gg-bm-variant {gap:7px;padding:6px 12px;border:1px solid #00000020;border-radius:10px;background:#f7f7f7;font-size:13.5px;text-decoration:none;transition:border-color .15s ease,background-color .15s ease}
.gg-bm-caret {width:9px;height:9px}
.gg-bm-cta {flex:0 0 auto;max-width:none;min-width:300px;min-height:54px;padding:0 32px;font-size:15px}
.gg-bm-sheet {max-width:1180px;margin-inline:auto;padding:18px 28px 22px;border-radius:20px 20px 0 0}
.gg-bm-group + .gg-bm-group {margin-top:18px}
.gg-bm-chips {gap:10px}
.gg-bm-chip {min-width:56px;min-height:44px;padding:0 18px;font-size:14.5px}
}
@media(min-width:1100px){
.gg-bm-bar {gap:36px}
.gg-bm-summary {max-width:880px}
.gg-bm-cta {min-width:340px}
}
@media(prefers-reduced-motion:reduce){.gg-bm,.gg-bm-sheet,.gg-bm-scrim,.gg-bm-cta,.gg-bm-chip {transition:none}.gg-bm-caret,.gg-bm.is-open .gg-bm-caret {animation:none}.gg-bm-cta.is-busy::after {animation-duration:1.6s}}
`;
  let render = () => {};
  const schedule = () => {
    if (stopped || frame) return;
    frame = requestAnimationFrame(() => {
      frame = 0;
      if (stopped) return;
      try { render(); } catch (error) { registry[key].destroy(); console.warn(key + ': stopped safely', error); }
    });
  };
  const observer = new MutationObserver(schedule);
  registry[key] = {destroy() {
    if (stopped) return;
    stopped = true;
    observer.disconnect();
    cancelAnimationFrame(frame);
    undo.reverse().forEach(fn => fn());
    delete registry[key];
  }};

  const copy = {
    bar: 'Snel toevoegen aan winkelwagen',
    options: 'Opties wijzigen',
    sheetTitle: 'Kies je opties',
    close: 'Sluiten',
    soldOut: 'uitverkocht'
  };
  let scrim, bar, row, sheet, groupsHolder, thumb, title, price, was, save, summary, variantLine, variantValue, cta, ctaLabel, spacer;
  let section, root, original, opened = false, signature = '', variantsRaw = '', variants = [];

  const optionNumber = index => parseInt(index.slice(-1), 10);
  const groupName = wrapper => {
    const label = wrapper.querySelector('.variant__label');
    if (!label) return '';
    const clone = label.cloneNode(true);
    clone.querySelectorAll('.variant__label-info').forEach(node => node.remove());
    return clone.textContent.trim();
  };
  const readVariants = () => {
    const holder = root.querySelector('[data-variant-json]');
    if (!holder || holder.value === variantsRaw) return;
    variantsRaw = holder.value;
    try { variants = JSON.parse(variantsRaw) || []; } catch (error) { variants = []; }
  };
  // Mirrors the option inputs the theme already renders, so the product form stays the source of truth.
  const readGroups = () => [...root.querySelectorAll('.variant-wrapper')].map(wrapper => {
    const select = wrapper.querySelector('select[data-variant-input]');
    const radios = select ? [] : [...wrapper.querySelectorAll('input[data-variant-input]')];
    const values = select ? [...select.options].map(option => option.value) : radios.map(radio => radio.value);
    const field = wrapper.querySelector('.variant-input-wrap');
    return {
      index: field?.dataset.index || select?.dataset.index || radios[0]?.dataset.index || '',
      name: groupName(wrapper) || field?.dataset.handle || '',
      current: select ? select.value : radios.find(radio => radio.checked)?.value || '',
      values, select, radios
    };
  }).filter(group => group.index && group.values.length);
  const pickableOf = groups => groups.filter(group => group.values.length > 1);
  const applyValue = (group, value) => {
    const input = group.select || group.radios.find(radio => radio.value === value);
    if (!input) return;
    if (group.select) {
      if (input.value === value) return;
      input.value = value;
    } else {
      if (input.checked) return;
      input.checked = true;
    }
    input.dispatchEvent(new Event('change', {bubbles: true}));
  };
  // A value is sold out when no available variant matches it together with the higher-priority options,
  // which is the same match the theme's dynamic variant picker performs.
  const soldOut = (groups, group, value) => {
    const rank = optionNumber(group.index);
    return !variants.some(variant => variant.available && variant[group.index] === value
      && groups.every(other => optionNumber(other.index) >= rank || variant[other.index] === other.current));
  };
  const currentVariant = groups => variants.find(variant => groups.every(group => variant[group.index] === group.current));
  const thumbSrc = groups => {
    const src = currentVariant(groups)?.featured_image?.src;
    if (src) return src + (src.includes('?') ? '&' : '?') + 'width=128';
    const template = section?.dataset.imgUrl;
    return template && template.includes('{width}') ? template.replace('{width}', '128') : '';
  };

  const setOpen = value => {
    const next = !!value && !summary.disabled;
    if (opened === next) return;
    opened = next;
    flag(bar, 'is-open', opened);
    flag(scrim, 'is-in', opened);
    set(summary, 'aria-expanded', String(opened));
    if (!opened && sheet.contains(document.activeElement)) summary.focus({preventScroll: true});
    schedule();
  };
  const onCta = () => {
    if (!original?.isConnected || original.disabled || original.getAttribute('aria-disabled') === 'true' || original.classList.contains('btn--loading')) return;
    const form = original.closest('form');
    setOpen(false);
    if (form && !form.checkValidity()) { scrollTo(original); form.reportValidity(); return; }
    original.click();
    schedule();
  };
  const buildUI = () => {
    scrim = own(element('div', 'gg-bm-scrim'));
    listen(scrim, 'click', () => setOpen(false));

    bar = own(element('aside', 'gg-bm'));
    bar.setAttribute('aria-label', copy.bar);
    sheet = element('div', 'gg-bm-sheet');
    sheet.id = 'gg-bm-sheet';
    groupsHolder = element('div', 'gg-bm-groups');
    const grip = element('button', 'gg-bm-grip');
    grip.type = 'button';
    grip.setAttribute('aria-label', copy.close);
    listen(grip, 'click', () => setOpen(false));
    const head = element('div', 'gg-bm-sheet-head');
    head.append(element('span', 'gg-bm-sheet-title', copy.sheetTitle));
    const close = element('button', 'gg-bm-close');
    close.type = 'button';
    close.setAttribute('aria-label', copy.close);
    const closeX = element('i', 'gg-bm-close-x');
    closeX.setAttribute('aria-hidden', 'true');
    close.append(closeX, document.createTextNode(copy.close));
    listen(close, 'click', () => setOpen(false));
    head.append(close);
    sheet.append(grip, head, groupsHolder);
    listen(groupsHolder, 'click', event => {
      const chip = event.target.closest('.gg-bm-chip');
      if (!chip) return;
      const groups = readGroups();
      const group = groups.find(item => item.index === chip.dataset.ggIndex);
      if (!group) return;
      applyValue(group, chip.dataset.ggValue);
      if (pickableOf(groups).length === 1) setOpen(false);
      schedule();
    });

    row = element('div', 'gg-bm-bar');
    thumb = element('img', 'gg-bm-thumb');
    thumb.alt = '';
    thumb.width = thumb.height = 48;
    thumb.loading = 'lazy';
    thumb.decoding = 'async';
    title = element('span', 'gg-bm-title');
    price = element('span', 'gg-bm-price');
    was = element('s', 'gg-bm-was');
    save = element('span', 'gg-bm-save');
    const prices = element('span', 'gg-bm-prices');
    prices.append(price, was, save);
    variantValue = element('span', 'gg-bm-variant-value');
    const caret = element('i', 'gg-bm-caret');
    caret.setAttribute('aria-hidden', 'true');
    variantLine = element('span', 'gg-bm-variant');
    variantLine.append(variantValue, caret);
    const meta = element('span', 'gg-bm-meta');
    meta.append(prices, variantLine);
    const lines = element('span', 'gg-bm-lines');
    lines.append(title, meta);

    // The whole product summary opens the option sheet, which keeps the tap target large on mobile.
    summary = element('button', 'gg-bm-summary');
    summary.type = 'button';
    summary.setAttribute('aria-controls', sheet.id);
    summary.append(thumb, lines);
    listen(summary, 'click', () => setOpen(!opened));

    cta = element('button', 'gg-bm-cta');
    cta.type = 'button';
    ctaLabel = element('span', 'gg-bm-cta-label');
    cta.append(ctaLabel);
    listen(cta, 'click', onCta);

    row.append(summary, cta);
    bar.append(sheet, row);
    spacer = own(element('div', 'gg-bm-spacer'));
    document.body.append(scrim, bar, spacer);
    listen(document, 'keydown', event => { if (event.key === 'Escape' && opened) setOpen(false); });
  };

  const syncSheet = (groups, pickable) => {
    const next = pickable.map(group => group.index + ':' + group.name + ':' + group.values.join('|')).join('~');
    if (next !== signature) {
      signature = next;
      groupsHolder.textContent = '';
      pickable.forEach(group => {
        const groupValue = element('span', 'gg-bm-group-value');
        groupValue.dataset.ggValueFor = group.index;
        const head = element('div', 'gg-bm-group-head');
        head.append(element('span', 'gg-bm-group-name', group.name), groupValue);
        const chips = element('div', 'gg-bm-chips');
        group.values.forEach(value => {
          const chip = element('button', 'gg-bm-chip', value);
          chip.type = 'button';
          chip.dataset.ggIndex = group.index;
          chip.dataset.ggValue = value;
          chips.append(chip);
        });
        const box = element('div', 'gg-bm-group');
        box.append(head, chips);
        groupsHolder.append(box);
      });
    }
    pickable.forEach(group => {
      const groupValue = groupsHolder.querySelector('[data-gg-value-for="' + group.index + '"]');
      if (groupValue) text(groupValue, group.current);
      groupsHolder.querySelectorAll('.gg-bm-chip[data-gg-index="' + group.index + '"]').forEach(chip => {
        const value = chip.dataset.ggValue;
        const out = soldOut(groups, group, value);
        set(chip, 'aria-pressed', String(value === group.current));
        flag(chip, 'is-out', out);
        if (out) set(chip, 'aria-label', value + ' \u2013 ' + copy.soldOut);
        else drop(chip, 'aria-label');
      });
    });
  };

  const syncBar = (groups, pickable) => {
    const src = thumbSrc(groups);
    shown(thumb, !!src);
    if (src) set(thumb, 'src', src);
    text(title, root.querySelector('.product-single__title')?.textContent.trim() || '');
    const amount = root.querySelector('[data-product-price]')?.textContent.trim() || '';
    text(price, amount);
    shown(price, !!amount);

    const compareWrap = root.querySelector('[data-product-price-wrap]');
    const compare = compareWrap && !compareWrap.classList.contains('hide')
      ? root.querySelector('[data-compare-price]')?.textContent.trim() || '' : '';
    text(was, compare);
    shown(was, !!compare);
    const savings = root.querySelector('[data-save-price]');
    const saved = savings && !savings.classList.contains('hide') ? savings.textContent.trim() : '';
    text(save, saved);
    shown(save, !!saved);

    shown(variantLine, pickable.length > 0);
    if (!pickable.length) {
      setOpen(false);
      drop(summary, 'aria-expanded');
      drop(summary, 'aria-label');
    } else {
      const chosen = pickable.map(group => group.current).join(' \u00b7 ');
      text(variantValue, chosen);
      set(summary, 'aria-expanded', String(opened));
      set(summary, 'aria-label', copy.options + ': ' + chosen);
    }
    if (summary.disabled !== !pickable.length) summary.disabled = !pickable.length;

    const busy = original.classList.contains('btn--loading');
    const blocked = original.disabled || original.getAttribute('aria-disabled') === 'true';
    const themeLabel = original.querySelector('[data-add-to-cart-text]')?.textContent.trim() || original.textContent.trim();
    text(ctaLabel, themeLabel);
    flag(cta, 'is-busy', busy);
    const disabled = busy || blocked;
    if (cta.disabled !== disabled) cta.disabled = disabled;
  };

  const hide = () => {
    if (!bar) return;
    setOpen(false);
    flag(bar, 'is-in', false);
    if (spacer.style.height !== '0px') spacer.style.height = '0px';
  };

  listen(window, 'scroll', schedule, {passive: true});
  listen(window, 'resize', schedule, {passive: true});
  render = () => {
    section = document.querySelector('[data-section-type="product"]');
    root = section?.querySelector('.product-single__meta');
    original = root?.querySelector('form.product-single__form [data-add-to-cart]');
    if (!location.pathname.includes('/products/') || !original) { hide(); return; }
    if (!bar) buildUI();
    readVariants();
    const groups = readGroups();
    const pickable = pickableOf(groups);
    syncSheet(groups, pickable);
    syncBar(groups, pickable);

    const overlay = document.documentElement.classList.contains('js-drawer-open')
      || document.documentElement.classList.contains('modal-open')
      || document.querySelector('dialog[open], .drawer.is-open, .drawer--is-open, .modal--is-active');
    // Only take over once the real add-to-cart button has scrolled off the top of the viewport.
    const show = !overlay && visible(original) && original.getBoundingClientRect().bottom < 0;
    if (!show) { hide(); return; }
    flag(bar, 'is-in', true);
    const height = Math.round(row.getBoundingClientRect().height) + 'px';
    if (spacer.style.height !== height) spacer.style.height = height;
  };

  const boot = () => {
    if (stopped) return;
    document.head.append(style);
    observer.observe(document.documentElement, {subtree: true, childList: true, characterData: true, attributes: true,
      attributeFilter: ['class', 'disabled', 'aria-disabled', 'aria-busy', 'data-rating', 'data-raters', 'data-product-id', 'value', 'hidden']});
    listen(document, 'variant:change', schedule);
    listen(document, 'change', schedule);
    listen(document, 'shopify:section:load', schedule);
    schedule();
  };
  if (document.readyState === 'loading') listen(document, 'DOMContentLoaded', boot, {once: true});
  else boot();
})();
